import React from "react";
import PropTypes from "prop-types";
import BalloonStyles from "./messagesBalloon.module.css";

const MessagesBalloon = ({ author, message, time }) => {
  return (
    <div
      className={
        author === "me"
          ? `${BalloonStyles.container}`
          : `${BalloonStyles.container_answer}`
      }
    >
      <div className={BalloonStyles.time}>{time}</div>
      <div className={BalloonStyles.message}>{message}</div>
    </div>
  );
};

MessagesBalloon.propTypes = {
  author: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
};

export default MessagesBalloon;
